import { render, staticRenderFns } from "./FourthComponent.vue?vue&type=template&id=a097beb0"
import script from "./FourthComponent.vue?vue&type=script&lang=js"
export * from "./FourthComponent.vue?vue&type=script&lang=js"
import style0 from "./FourthComponent.vue?vue&type=style&index=0&id=a097beb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports